<template>
  <div class="vld-parent" ref="investor_funds">
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              A Stars está estrategicamente posicionada para destacar Startups
              no cenário nacional e internacional. Confira abaixo os fundos de
              investimentos Stars que você, investidor, participa!
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="fund in funds"
              :key="fund.id"
            >
              <div class="card card-profile shadow flex-grow-1">
                <div class="row justify-content-center">
                  <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                      <img src="/img/pages/fund.png" class="rounded-circle" />
                    </div>
                  </div>
                </div>
                <div class="card-body pt-7 pb-2">
                  <div class="text-center mt-5">
                    <h3 class="text-center tag-title">
                      <i class="ni ni-tag mr-2"></i>
                      <span class="tag">{{ fund.tag }}</span>
                    </h3>
                    <div class="col-12 text-center">
                      <badge type="info">{{
                        fund.status === "open" ? "Regular" : "Encerrado"
                      }}</badge>
                    </div>
                    <h3 class="mt-3">
                      <i class="ni ni-pin-3 mr-2"></i>{{ fund.city || "..." }},
                      {{ fund.state || "..." }}
                    </h3>
                    <div class="row mt-2">
                      <div class="col text-center text-muted">
                        {{ getTypeLabel(fund.type) }}, com valor previsto de
                        {{ formatValue(fund.value) }},
                        {{ fund.number_investors }} investidores e
                        {{ fund.batches }} batches de startups.
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-footer text-center vld-parent"
                  :ref="`fund_${fund.id}`"
                >
                  <div class="vld-parent">
                    <base-button
                      type="primary"
                      icon="fas fa-chart-line"
                      title="Ver métricas do fundo"
                      @click="openModalMetrics(fund)"
                      >Métricas</base-button
                    >
                    <base-button
                      type="warning"
                      icon="fas fa-coins"
                      title="Ver relatório financeiro"
                      @click="openModalReports(fund)"
                      >Financeiro</base-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row">
              <div class="col text-center">
                <span class="bg-white rounded shadow p-3">
                  Você não está cadastrado em nenhum fundo de investimentos
                  STARS
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :show.sync="empty"
      :closeOnClick="false"
      modal-classes="modal-dialog-centered modal-default"
    >
      <h6 class="modal-title mb-6" id="modal-title-notification">Atenção!</h6>
      <div class="text-center">
        <i class="fa fa-exclamation-circle fa-3x"></i>
        <h4 class="heading mt-4">
          Prezado
          <span class="text-warning text-default-case">investidor</span>,
        </h4>
        <p class="my-4">
          Você não está vinculado a nenhum
          <span class="text-warning font-weight-400"
            >fundo de investimentos STARS</span
          >
          até o momento. Em caso de qualquer dúvida, sinta-se livre para
          <base-button
            type="danger"
            class="ml-auto"
            size="sm"
            @click="$router.push('/investidor/suporte')"
            >Contatar o suporte
          </base-button>
        </p>
      </div>
      <div slot="footer">
        <p class="text-right mb-0">
          Cordialmente,<br />
          <span class="font-weight-600"
            >Equipe <span class="text-warning">STARS</span></span
          >.
        </p>
      </div>
    </modal>
    <modal
      :show.sync="modals.metrics.show"
      modal-classes="modal-dialog-centered"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Visualização
      </h6>
      <div class="text-center">
        <i class="fa fa-chart-line fa-3x"></i>
        <h4 class="mt-4">
          Métricas do fundo
          <span class="text-warning">{{ modals.metrics.fund.tag }}</span>
        </h4>
        <ul class="text-left description mt-4">
          <li class="mb-1">
            <b>Valor total captado: </b>
            {{ ptBrNumber(modals.metrics.fund.total_raised) }}
          </li>
          <li class="mb-1">
            <b>Valor em caixa: </b>
            {{ ptBrNumber(modals.metrics.fund.cash_value) }}
          </li>
          <li class="mb-1">
            <b>Investimento total nas startups: </b>
            {{ ptBrNumber(modals.metrics.fund.total_investment) }}
          </li>
          <li class="mb-1">
            <b>Investimento nas startups até o momento: </b>
            {{ ptBrNumber(modals.metrics.fund.current_investment) }}
          </li>
        </ul>
        <div class="row" v-if="modals.metrics.fund.note">
          <div class="col-6 offset-3">
            <hr class="my-3" />
          </div>
          <div class="col-12">
            <p class="description mb-0">
              <b>Observações: </b> {{ modals.metrics.fund.note }}
            </p>
          </div>
          <div class="col-6 offset-3">
            <hr class="my-3" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="description text-muted text-right mb-0">
              Última atualização em
              {{ formatTimestamp(modals.metrics.fund.updated_at) }}.
            </p>
          </div>
        </div>
      </div>
      <div slot="footer">
        <base-button type="white" @click="modals.metrics.show = false">
          Fechar
        </base-button>
      </div>
    </modal>
    <modal
      :show.sync="modals.reports.show"
      modal-classes="modal-dialog-centered modal-xl"
      body-classes="pb-0"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Visualização
      </h6>
      <div>
        <div class="col-12 text-center">
          <i class="fa fa-chart-line fa-3x"></i>
          <h4 class="mt-4">
            Relatórios financeiros do fundo
            <span class="text-warning">{{ modals.reports.fund.tag }}</span>
          </h4>
          <div class="col-12 mt-4" v-if="modals.reports.fund">
            <p v-if="!modals.reports.fund.reports.length" class="text-center">
              <badge type="primary"
                >Ainda não existem relatórios vinculados ao fundo</badge
              >
            </p>
            <tabs
              v-else
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="pt-0"
              type="primary"
            >
              <card shadow bodyClasses="px-2 py-3">
                <tab-pane
                  :title="report.title"
                  v-for="report in modals.reports.fund.reports"
                  :key="report.title"
                >
                  <span slot="title">
                    <i class="fas fa-coins mr-2"></i>
                    {{ report.title }}
                  </span>
                  <div>
                    <quill-editor
                      v-model="report.report"
                      :options="editorReadOnly"
                      disabled="disabled"
                    >
                    </quill-editor>
                    <p class="description text-muted text-right mb-0">
                      Relatório adicionado em
                      {{ formatTimestamp(report.created_at) }}. Última
                      atualização em {{ formatTimestamp(report.updated_at) }}.
                    </p>
                  </div>
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </div>
      <div slot="footer">
        <base-button type="white" @click="modals.reports.show = false">
          Fechar
        </base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import api from "@/services/api";

export default {
  name: "funds",
  components: {
    quillEditor,
  },
  data() {
    return {
      funds: [],
      empty: false,
      modals: {
        metrics: {
          show: false,
          fund: "",
        },
        reports: {
          show: false,
          fund: "",
        },
      },
      editorReadOnly: {
        placeholder: "N/A",
        readOnly: true,
        theme: "bubble",
      },
    };
  },
  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.investor_funds,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    try {
      const { data: funds } = await api.get("/investor-funds");
      if (funds.length) this.funds = funds;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as informações");
    }
  },
  methods: {
    getTypeLabel(fundType) {
      const separator = fundType === "Misto" ? "" : "de";
      return `Fundo ${separator} ${fundType}`;
    },
    openModalMetrics(fund) {
      this.modals.metrics.fund = fund;
      this.modals.metrics.show = true;
    },
    async openModalReports(fund) {
      this.modals.reports.fund = "";
      const loader = this.$loading.show({
        container: this.$refs[`fund_${fund.id}`][0],
        width: 50,
        height: 50,
      });
      try {
        const { data } = await api.get(`/investor-fund-reports/${fund.id}`);
        fund.reports = data;
        this.modals.reports.fund = fund;
        this.modals.reports.show = true;
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar o relatório");
      } finally {
        loader.hide();
      }
    },
    ptBrNumber(value) {
      if (!value) return "Não definido";

      return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
  },
};
</script>
<style scoped>
.card {
  margin-top: 10px;
}
.text-default-case {
  text-transform: none !important;
}
.card-profile-image img {
  width: 180px;
  height: 180px;
}
</style>
<style>
p > strong {
  font-weight: bold !important;
}

.di-container-edditable .quill-editor .ql-container,
.di-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 10rem;
  width: 100%;
}

.di-container-read-only .quill-editor .ql-container,
.di-container-read-only .quill-editor .ql-container .ql-editor {
  max-height: 400px;
  width: 100%;
}
</style>
